/**
 * Arreglo con el nombre de cada mes
 */
export const MESES =Object.freeze( [
"Enero",
"Febrero",
"Marzo",
"Abril",
"Mayo",
"Junio",
"Julio",
"Agosto",
"Septiembre",
"Octubre",
"Noviembre",
"Diciembre",
])

/**
 * un arreglo de objetos que tiene los meses con su id
 * @constant {Array<{id: number, label: string}>}
 */
export const MESES_OBJ = MESES.map((mes, i) => ({
  id: i+1,
  label: mes,
}));


export const FORMATS={
  DATE_FORMAT:"DD/MM/YYYY",
  DATE_TIME_FORMAT:"DD/MM/YYYY HH:mm",
}
